"use client";

import Image from "next/image";
import classNames from "classnames";
import { useRouter } from "next/navigation";
import AnimatedContent from "../AnimatedContent";
import { useTranslation } from "react-i18next";

const MainSection = () => {
  const { t } = useTranslation();
  const router = useRouter();

  const baseButtonClass =
    "px-6 py-2 md:px-8 md:py-3 text-sm md:text-base font-semibold rounded-md transition-colors";

  const buttons = [
    {
      label: "MAIN_SECTION_BUTTON_IR",
      className:
        "border border-white/60 hover:bg-gray-300 hover:text-black cursor-not-allowed!",
      onClick: undefined,
    },
    {
      label: "MAIN_SECTION_BUTTON_CONTACT",
      className: "bg-primary hover:bg-primary-hover",
      onClick: () => router.push("/newsroom"),
    },
  ];

  return (
    <section
      id="main-section"
      className="relative h-screen w-full overflow-hidden text-white"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <Image
          src="https://zipshow-static-web.s3.ap-northeast-2.amazonaws.com/homepage/color-to-life-biz/main_background.png"
          alt="Color to Life Main Background"
          fill
          quality={90}
          priority
          sizes="100vw"
          className="object-cover"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/70" />

      {/* Content */}
      <AnimatedContent className="relative z-10 flex flex-col items-center md:items-start justify-center h-full px-4 sm:px-8 max-w-[1600px] 4xl:max-w-[1920px] mx-auto">
        <h1 className="text-center md:text-left font-semibold! text-shadow-md">
          {t("MAIN_SECTION_CONTENT")} <br />
          <span className="text-primary font-bold">
            {t("MAIN_SECTION_CONTENT_POINT")}
          </span>
        </h1>

        {/* CTA Buttons */}
        <div className="mt-6 md:mt-10 flex gap-2 md:gap-4">
          {buttons.map((button) => (
            <button
              type="button"
              onClick={button.onClick}
              key={button.label}
              className={classNames(baseButtonClass, button.className)}
              disabled={!button.onClick}
            >
              {t(button.label)}
            </button>
          ))}
        </div>
      </AnimatedContent>
    </section>
  );
};

export default MainSection;
